import { z } from "zod";

import { SubOptionItemInputSchema } from "@/lib/zod/__generated__/validation-schema";

import { priceObjectZodSchema } from "@/components/features/_shared/validation-schema/validation-schema";

export const SubOptionsZodSchema = z
	.array(
		SubOptionItemInputSchema.extend({
			name: z.string().min(1).max(150),
			maxDailyStockNum: z.number().int().min(1).max(9_999),
			price: priceObjectZodSchema,
		}) // ↓ 複数の値によるバリデーションを設定するために、refineを使用している
			// サブオプションの開始時間と終了時間
			.refine(
				({ startAt, endAt, isShowTimeSchedule }) => {
					if (startAt && endAt && isShowTimeSchedule) {
						return startAt < endAt;
					}

					return true;
				},
				{
					message: "開始時間は終了時間よりも前になるように設定してください",
					path: ["startAt"],
				},
			),
	)
	.nullish();
